import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { bootstrap } from "./app/bootstrap";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { router } from "./app/routes";
import { store } from "./app/store";
import { registerServiceWorker, watchThemeColor } from "./shared/lib/pwa";
import "./styles/index.css";

// Соединение поднимается до рендера и вне дерева React: StrictMode
// монтирует эффекты дважды, и сокет в useEffect задвоился бы.
bootstrap();
// Установка на главный экран (M7): цвет строки состояния и service worker.
watchThemeColor();
registerServiceWorker();

const container = document.getElementById("root");
if (container === null) throw new Error("Не найден #root");

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <ErrorBoundary area="root">
        <RouterProvider router={router} />
      </ErrorBoundary>
      {/* На телефоне тосты — над нижней панелью разделов. */}
      <Toaster
        position="bottom-right"
        mobileOffset={{ bottom: "calc(var(--tabbar-h) + 16px)" }}
        richColors
        closeButton
      />
    </Provider>
  </StrictMode>,
);
